const app = Stimulus.Application.start();
app.register("vehicles", class extends Stimulus.Controller {
    static get values() {
        return {page: Number}
    }

    static get targets() {
        return ['list', 'typeSelector', 'searchInput'];
    }

    connect() {
        this.pageValue = 1;
        this.loadVehicles();
        this.timer = null;
        if (!this.hasListTarget) {
            this.alternateListTarget = document.getElementById('ecu-list');
        }
        this.currentLocale = (typeof window.Shopify !== 'undefined') ? window.Shopify.locale : 'en';
    }

    searchVehicles(e) {
        const query = this.hasSearchInputTarget ? this.searchInputTarget.value : '';
        const selector = this.hasTypeSelectorTarget ? this.typeSelectorTarget.value : '';

        this.pageValue = 1;

        // debounce the search : wait 200ms before sending the request
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.loadVehicles(query, selector);
        }, 200);
    }


    loadPage(e) {
        this.pageValue = e.target.dataset.vehiclesPageValue;
        const query = this.searchInputTarget.value || '';
        const selector = this.typeSelectorTarget.value || '';
        this.loadVehicles(query, selector);
    }

    loadVehicles(query = '', selector = '') {

        const url = this.builSearchUrl(query, selector);
        fetch(url,
            {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                }
            }
        )
            .then(response => response.json())
            .then(data => {
                if (data.data.length === 0) {
                    console.log('no results found');
                    // display no results found
                    this.listTarget.innerHTML = document.getElementById('empty-list').innerHTML;
                    // clear pagination
                    document.querySelector('.pagination').innerHTML = '';
                    return;
                }

                if (this.hasListTarget) {
                    this.listTarget.innerHTML = '';
                } else {
                    this.alternateListTarget.innerHTML = '';
                }
                data.data.forEach(item => this.populateItemTemplate(item))
                this.populatePagination(data);
                setTimeout(() => {
                    if (this.hasListTarget) {

                        this.listTarget.childNodes.forEach(node => {
                            node.style.opacity = 1;
                        })
                    } else {
                        this.alternateListTarget.childNodes.forEach(node => {
                            node.style.opacity = 1;
                        })
                    }
                }, 50)
            })
            .catch(error => {
                console.error(error);
                this.listTarget.innerHTML = document.getElementById('empty-list').innerHTML;
                document.querySelector('.pagination').innerHTML = '';
            })
    }

    controlUnitFilter(e) {
        this.searchVehicles();
    }

    populateItemTemplate(itemData) {
        const template = document.getElementById('ecu-list-element').innerHTML;

        let populatedTemplate =
            template.replace('**manuf**', itemData.manufacturer)
                .replace('**logo**', `https://assets.autotuner.com/brand/logo/${itemData.manufacturerId}.png`)
                .replace('**modelVersionYear**', `${itemData.model} ${itemData.version ?? ''} ${itemData.from}`)
                .replace('**engine**', `${itemData.engine} ${itemData.power}Hp/${itemData.torque}Nm`)
                .replace('**ecu**', `<span>${itemData.ecuManufacturer} ${itemData.ecu}</span> <small>${itemData.mcu}</small>`)
                // to lower case and replace spaces with dashes and delete special characters .replace(/[^a-zA-Z0-9-]/g, '')
                .replace('**ecu-url**', this.getECUUrl(itemData.ecuManufacturer, itemData.ecu, itemData.mcu))
                .replace('**methods**', itemData.methods.map(method =>
                    `<li class="icon ${method.replace(/ /g, '-')}">
                                <a title="${method}" href="${this.buildMethodLink(method)}" target="_blank">
                                    <span>${method}</span>
                                </a>
                            </li>`).join(''))
                .replace('**ecu-type**', itemData.ecuType === 'engine' ? 'ECU' : itemData.ecuType === 'gearbox' ? 'TCU' : itemData.ecuType)
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = populatedTemplate.trim();
        // tempDiv.firstChild.style.opacity = 0;
        // tempDiv.firstChild.style.transition = 'opacity 0.5s';
        if (this.hasListTarget) {
            this.listTarget.appendChild(tempDiv.firstChild)
        } else {
            this.alternateListTarget.appendChild(tempDiv.firstChild)
        }
    }

    buildMethodLink(method) {
        // add the current locale to the method link if different from en
        if (this.currentLocale === 'en') {
            return `/pages/flash-method/${method.replace(/_/g, '-')}`;
        }
        if (this.currentLocale === 'pt-PT' || this.currentLocale === 'pt-BR') {
            return `/pt/pages/flash-method/${method.replace(/_/g, '-')}`;
        }
        return `/${this.currentLocale}/pages/flash-method/${method.replace(/_/g, '-')}`;
    }


    populatePagination(data) {
        const pagination = document.querySelector('.pagination');
        pagination.innerHTML = '';
        // create a button for the fist page
        const startPage = (this.pageValue > 5) ? this.pageValue - 5 : 1;
        let endPage = (this.pageValue > 5) ? this.pageValue + 5 : 10;
        if (endPage > data.nbPage) {
            endPage = data.nbPage;
        }
        if (startPage > 1) {
            pagination.appendChild(this.createButton('first', 1));
        }

        for (let i = startPage; i <= endPage; i++) {
            const button = this.createButton(i, i);
            if (i === this.pageValue) {
                button.classList.add('active')
            }
            pagination.appendChild(button);
        }
        if (endPage < data.nbPage) {
            pagination.appendChild(this.createButton('last', data.nbPage));
        }

    }

    createButton(text, page) {
        const button = document.createElement('button');
        button.classList.add('btn');
        button.dataset.vehiclesPageValue = page;
        button.textContent = text;
        button.addEventListener('click', this.loadPage.bind(this));
        return button;
    }

    builSearchUrl(query, selector) {
        let searchQuery = '';
        const encodedQuery = encodeURIComponent(query).replace(/%20/g, '+');
        searchQuery = `search=${encodedQuery}`;
        if (selector.toLowerCase() === 'truck') {
            selector = 'trucks';
        }
        if (selector.toLowerCase() === 'tractor') {
            selector = 'agri';
        }
        const encodedSelector = encodeURIComponent(selector);
        searchQuery = `${searchQuery}&type=${encodedSelector}`;

        const controlUnitFilter = document.querySelector('input[name="controlUnit"]:checked')?.value;
        let ecuType = '';
        if (controlUnitFilter !== null) {
            if (controlUnitFilter === 'ECU') {
                ecuType = 'engine';
            } else if (controlUnitFilter === 'TCU') {
                ecuType = 'gearbox';
            } else {
                ecuType = '';
            }
            ecuType = encodeURIComponent(ecuType);
            ecuType = ecuType.replace(/%20/g, '+');
            searchQuery = `${searchQuery}&ecuType=${ecuType}`;
        }

        if (window.currentEcuId) {
            let ecuId = encodeURIComponent(window.currentEcuId);
            ecuId = ecuId.replace(/%20/g, '+');
            searchQuery = `${searchQuery}&ecuId=${ecuId}`;
        }
        if (window.currentManufacturer) {
            let manufacturer = encodeURIComponent(window.currentManufacturer);
            manufacturer = manufacturer.replace(/%20/g, '+');
            manufacturer = manufacturer.toLowerCase();
            searchQuery = `${searchQuery}&brand=${manufacturer}`;
        }

        if (window.currentMethod) {
            let method = encodeURIComponent(window.currentMethod);
            method = method.replace(/%20/g, '+');
            method = method.toLowerCase();
            searchQuery = `${searchQuery}&method=${method}`;
        }
        if (window.forAtOne) {
            searchQuery = `${searchQuery}&atOne=true`;
        }
        return `${window.searchEndpoint}/search/page/${this.pageValue}?${searchQuery}`;
    }


    getECUUrl(ecuManufacturer, ecu, mcu) {
        let url = '/pages/ecu/' + `${ecuManufacturer}-${ecu.replace(/[^a-zA-Z0-9-]/g, '')}-${mcu.replace(/[^a-zA-Z0-9-]/g, '')}`.toLowerCase().replace(/ /g, '-');
        if (this.currentLocale === 'en') {
            return url
        }
        if (this.currentLocale === 'pt-PT' || this.currentLocale === 'pt-BR') {
            return `/pt${url}`
        }
        return `/${this.currentLocale}${url}`
    }
})